<div [formGroup]="formVariant">
  <div formGroupName="nutrition">
    <mat-table [dataSource]="dataSource" class="nutritional-table">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <strong>{{ element.translationKey | translate }}</strong>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="autoValue">
        <mat-header-cell *matHeaderCellDef> {{ 'NUTRITION.AUTO_VALUE' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field *ngIf="element.type === 'select'">
            <mat-select [value]="element.autoValue" id="RecipesModifyMoreInfosNutritionalNutriscoreAutoTxt" [disabled]="true">
              <mat-option *ngFor="let option of element.options" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="element.type !== 'select'">
            <input
              id="RecipesModifyMoreInfosNutritional{{ element.name }}AutoTxt"
              matInput
              [type]="element.type"
              [disabled]="true"
              [value]="element.autoValue"
            />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="userValue">
        <mat-header-cell *matHeaderCellDef> {{ 'NUTRITION.DISPLAYED_VALUE' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field *ngIf="element.type === 'select'">
            <mat-select id="RecipesModifyMoreInfosNutritionalNutriscoreTxt" formControlName="{{ element.name }}">
              <mat-option *ngFor="let option of element.options" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="element.type === 'text' || element.type === 'number'">
            <input
              matInput
              [type]="element.type"
              id="RecipesModifyMoreInfosNutritional{{ element.name | titlecase }}Txt"
              formControlName="{{ element.name }}"
              [min]="element.min"
              [max]="element.max"
            />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Table Footer -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</div>
